












































































































































































































































import { Component, Vue, Ref, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import SuporteConveniosStore from '@/components/Suporte/Store/SuporteConveniosStore'
import { onlyNumber } from '@/utils/common'

@Component
export default class ComponentModalSuporteConvenio extends Vue {
  $refs!: {
    formConvenio: any,
    formConvenioPlano: any,
  }

  formConvenio: any = {
    valid: true,
    nome: [(v: any) => !!v || 'Campo obrigatório.'],
    prazoMaximoEmDiasParaAgendamento: [(v: any) => this.validatePrazoMaximoEmDiasParaAgendamento(v) || 'O prazo máximo inferior ao prazo em dias para triagem.'],
  }

  validatePrazoMaximoEmDiasParaAgendamento(prazo: number) {
    let prazoParaTriagem = this.getSuporteConveniosStore.convenio.prazoEmDiasParaTriagem
    // @ts-ignore
    if ([undefined, null, ''].includes(prazoParaTriagem)) prazoParaTriagem = 0
    // @ts-ignore
    if ([undefined, null, ''].includes(prazo)) prazo = 0
    if ((prazo === 0 && prazoParaTriagem === 0) || prazoParaTriagem === 0) return true
    return prazo > prazoParaTriagem
  }

  loadSaveOrUpdateConvenio: boolean = false
  loadConvenioPlano: boolean = false
  loadUpdatePlano: boolean = false
  convenioPlano: any = {}

  get getSuporteConveniosStore() {
    return getModule(SuporteConveniosStore, this.$store)
  }

  get loadingUpdatePlano() {
    return this.loadUpdatePlano
  }

  set loadingUpdatePlano(value: boolean) {
    this.loadUpdatePlano = value
  }

  get loadingConvenioPlano() {
    return this.loadConvenioPlano
  }

  set loadingConvenioPlano(value: boolean) {
    this.loadConvenioPlano = value
  }

  get loadingSaveOrUpdateConvenio() {
    return this.loadSaveOrUpdateConvenio
  }

  set loadingSaveOrUpdateConvenio(value: boolean) {
    this.loadSaveOrUpdateConvenio = value
  }

  get showModalConvenio() {
    return this.getSuporteConveniosStore.modal.convenio
  }

  set showModalConvenio(value: boolean) {
    this.getSuporteConveniosStore.setModal({ name: 'convenio', value })
  }

  onlyNumberUtil(value) {
    return onlyNumber(value)
  }

  async convenioPlanoChange(id: any) {
    this.loadingConvenioPlano = true
    this.getSuporteConveniosStore.setConvenioPlanoById(id)
    this.loadingConvenioPlano = false
  }

  async saveOrUpdateConvenio() {
    this.loadingSaveOrUpdateConvenio = true

    if (this.$refs.formConvenio.validate()) {
      const { mode } = this.getSuporteConveniosStore

      const response = await this.getSuporteConveniosStore.upsertConvenioHospital()

      if (response.success) {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: `Convenio ${mode === 'CREATE' ? 'criado' : 'alterado'} com sucesso! ${String.fromCodePoint(0x1F642)}`,
          icon: 'done',
          color: '#2E7D32',
        })
        await this.getSuporteConveniosStore.getConvenios()
        this.showModalConvenio = false
      } else {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: response.message ? `${response.message} ${String.fromCodePoint(0x1F615)}` : `Ocorreu um erro ao ${mode === 'CREATE' ? 'criar' : 'alterar'} o convenio ${String.fromCodePoint(0x1F615)}`,
          icon: 'warning',
          color: '#C62828',
        })
      }
    }

    this.loadingSaveOrUpdateConvenio = false
  }

  async saveOrUpdateConvenioPlano() {
    this.loadingUpdatePlano = true

    if (this.$refs.formConvenioPlano.validate()) {
      const response = await this.getSuporteConveniosStore.upsertConvenioPlanoHospital()

      if (response.success) {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: `Plano alterado com sucesso! ${String.fromCodePoint(0x1F642)}`,
          icon: 'done',
          color: '#2E7D32',
        })
        this.$refs.formConvenioPlano.reset()
        this.getSuporteConveniosStore.clearConvenioPlano()
        await this.getSuporteConveniosStore.getAllConvenioPlanoByConvenio()
      } else {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: response.message ? `${response.message} ${String.fromCodePoint(0x1F615)}` : `Ocorreu um erro ao alterar o plano ${String.fromCodePoint(0x1F615)}`,
          icon: 'warning',
          color: '#C62828',
        })
      }
    }

    this.loadingUpdatePlano = false
  }

  showModalConvenioPlano() {
    this.getSuporteConveniosStore.setMode({ mode: 'CREATE' })
    this.getSuporteConveniosStore.setModal({ name: 'convenioPlano', value: true })
  }

  @Watch('showModalConvenio')
  onChangeShowModalConvenio(value: boolean) {
    if (!value) {
      this.getSuporteConveniosStore.clearConvenio()
      this.getSuporteConveniosStore.setMode({ modal: 'convenio', mode: 'CREATE' })
      this.$refs.formConvenio.resetValidation()
      if (this.getSuporteConveniosStore.convenio.id) {
        this.$refs.formConvenioPlano.reset()
      }
    }
  }
}
